/* RENTRASPA: cart "You save" amount (5 Oct 2026).
   Saving = original cart total - the estimated total shown on the page.
   The Sami Wholesale slab discount is not part of cart.total_discount; Sami's script only
   rewrites the displayed total (.samitaWS-customized-price), so the amount is read from the page.
   The bar stays hidden until the figure is settled, so a buyer never sees a lower first number. */
(function () {
  if (window.__rsCartSavings) return;
  window.__rsCartSavings = true;

  var samiOnPage = !!document.querySelector('script[src*="samita.wholesale"]');
  var timer = null;

  function num(el) {
    if (!el) return NaN;
    var s = el.querySelector('.samitaWS-customized-price');
    var m = ((s || el).textContent || '').match(/\d[\d,]*(?:\.\d+)?/);
    return m ? parseFloat(m[0].replace(/,/g, '')) : NaN;
  }
  function fmt(r) {
    var t = Math.round(r * 10), w = Math.floor(t / 10), d = t % 10;
    return 'Rs. ' + w.toLocaleString('en-US') + (d ? '.' + d : '');
  }

  function apply() {
    var bar = document.querySelector('.rs-savings[data-rs-orig]');
    if (!bar) return;
    var totalEl = document.querySelector('#main-cart-footer .totals__total-value');
    if (!totalEl) return;
    /* The cart re-renders this block on every quantity change, so time the wait from when this bar appeared. */
    if (!bar.__rsSeen) bar.__rsSeen = Date.now();
    /* Wait (up to 3 s) for Sami to rewrite the total, so the first figure shown is the final one. */
    if (samiOnPage && !totalEl.querySelector('.samitaWS-customized-price') && Date.now() - bar.__rsSeen < 3000) {
      schedule(400);
      return;
    }
    var orig = parseInt(bar.getAttribute('data-rs-orig'), 10) / 100;
    var total = num(totalEl);
    if (isNaN(orig) || isNaN(total)) return;
    var save = Math.round((orig - total) * 10) / 10;
    var strong = bar.querySelector('[data-rs-save]');
    if (save > 0.05 && strong) {
      var txt = fmt(save);
      if (strong.textContent !== txt) strong.textContent = txt;
      if (bar.hidden) bar.hidden = false;
    } else if (!bar.hidden) {
      bar.hidden = true;
    }
  }

  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(apply, ms || 120);
  }

  if (window.MutationObserver) {
    new MutationObserver(function () { schedule(120); }).observe(document.documentElement, {
      childList: true, subtree: true, characterData: true
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { schedule(0); });
  else schedule(0);
})();
